import { Component,AfterViewChecked ,OnInit, ChangeDetectorRef } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { AuthService } from '@app/shared';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  animations: [
    trigger('slideInOut', [
      state(
        'in',
        style({
          transform: 'translate3d(0%, 0%, 0%)'
        })
      ),
      state(
        'out',
        style({
          transform: 'translate3d(100%, 0%, 0%)'
        })
      ),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('400ms ease-in-out'))
    ])
  ]
})

export class HomeComponent implements AfterViewChecked {
  myclass: any;
  menuState = 'out';
  //isLoggined: any;
  //test: any;
  //msg = '';
  isClosed = false;
  //@ViewChild('menuBtn') menuBtn: ElementRef;

  constructor(public auth: AuthService, private cd: ChangeDetectorRef) { }

  ngOnInit() {
    // this.router.events.subscribe(event => {
    //   if (event instanceof NavigationEnd) {
    //     // Hide loading indicator
    //     console.log('navifationEnd');
    //   }
    // });   
  }

  ngAfterViewChecked(){
    this.cd.detectChanges();
  }
 
  logout() {
    this.auth.logout();
  }

  toggleMenu(event) {
    this.menuState = this.menuState === 'out' ? 'in' : 'out';
    this.hamburger_cross(event);
  }

  hamburger_cross(event) {
    if (this.isClosed === true) {
      document?.getElementById('wrapper')?.classList?.toggle('fade-in');
      document?.getElementById('wrapper')?.classList?.remove('toggled');
      event?.target?.classList?.remove('is-open');
      event?.target?.classList?.add('is-closed');
      this.isClosed = false;
    } else {
      event?.target?.classList?.remove('is-closed');
      event?.target?.classList?.add('is-open');
      document?.getElementById('wrapper')?.classList?.toggle('toggled');
      this.isClosed = true;
    }
  }
}